/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ConduitSettingsSizeTagComponent } from './conduit-settings-size-tag.component';
import { SysqueDropdownOptionsLineModule } from '../../../../../../../../../../../shared/ui/src/lib/components/sysque-dropdown-options-line';
import { SysqueNumberBoxOptionsLineModule } from '../../../../../../../../../../../shared/ui/src/lib/components/sysque-number-box-options-line';
import { SysqueRadioButtonOptionsLineModule } from '../../../../../../../../../../../shared/ui/src/lib/components/sysque-radio-button-options-line';
import { SysqueCheckBoxOptionsLineModule } from '../../../../../../../../../../../shared/ui/src/lib/components/sysque-check-box-options-line';
import { SysqueLocationOptionsLineModule } from '../../../../../../../../../../../shared/ui/src/lib/components/sysque-location-options-line';

@NgModule({
  declarations: [ConduitSettingsSizeTagComponent],
  imports: [
    CommonModule,
    FormsModule,
    SysqueDropdownOptionsLineModule,
    SysqueNumberBoxOptionsLineModule,
    SysqueRadioButtonOptionsLineModule,
    SysqueCheckBoxOptionsLineModule,
    SysqueLocationOptionsLineModule
  ],
  exports: [ConduitSettingsSizeTagComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ConduitSettingsSizeTagModule {}
